import { COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS } from '@core/components/component-factory/component-factory-config-input.registry';
import type { ConfigComponentContract } from '@shared/utils/content-builder/config-component-contract';
import { computedResolvedConfig } from '@shared/utils/content-builder/block-config-computed-resolver';
import type { ModalHeaderBlockConfig } from '@front-platform/content-builder';
import { modalHeaderBlockResolveConfig } from '@front-platform/content-builder';
import { Component, input } from '@angular/core';

import { ModalsService } from '@core/services/modals/modals.service';
export interface ModalHeaderBlockRuntimeConfig {
  'modal_handle'?: string;
}

export type ModalHeaderBlockConfigInput = Partial<
  Omit<ModalHeaderBlockConfig, keyof ModalHeaderBlockRuntimeConfig> & ModalHeaderBlockRuntimeConfig
>;
export type ModalHeaderBlockResolvedConfig = Omit<
  ModalHeaderBlockConfig,
  keyof ModalHeaderBlockRuntimeConfig
> &
  Partial<ModalHeaderBlockRuntimeConfig>;
export interface ModalHeaderBlockContract extends ConfigComponentContract<
  ModalHeaderBlockConfigInput,
  ModalHeaderBlockResolvedConfig
> {}

@Component({
  selector: 'app-modal-header-block',
  templateUrl: './modal-header-block.component.html',
  standalone: false,
})
export class ModalHeaderBlockComponent implements ModalHeaderBlockContract {
  readonly config = input<ModalHeaderBlockConfigInput>({});
  readonly resolvedConfig = computedResolvedConfig<
    ModalHeaderBlockConfig,
    ModalHeaderBlockRuntimeConfig
  >(modalHeaderBlockResolveConfig, () => ({ config: this.config() }));
  get modalHandle(): string {
    return this.resolvedConfig()['modal_handle'] as unknown as string;
  }
  get heading(): string | undefined {
    return this.resolvedConfig()['heading'] as unknown as string | undefined;
  }
  get displayCloseIcon(): boolean {
    return this.resolvedConfig()['display_close_icon'] as unknown as boolean;
  }

  constructor(private readonly modalsService: ModalsService) {}

  close(): void {
    this.modalsService.close(this.modalHandle);
  }
}
COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS.set(ModalHeaderBlockComponent, { 'keyAliases': {} });
